module.exports = __webpack_public_path__ + "static/media/BM7100-59H.418c1264.png";